// Public help centre (Crisp Helpdesk). Mirrors HELP_CENTRE_URL in the root server.ts, which
// 301-redirects the legacy /help, /support and /trengo paths (and their language-prefixed
// variants) here. Linking to it directly keeps the visitor off a redirect hop.
export const HELP_CENTRE_URL = "https://stippl.crisp.help/en/";
